export const states = ['VIC', 'QLD', 'WA', 'TAS', 'NT', 'SA', 'ACT', 'NSW'];
